import { useEffect, useRef } from 'react';
import { useToastContext } from '@/layout/context/toast-context';
/**
 * Shows a PrimeReact toast when a Redux slice sets `errorMessage` after a rejected thunk.
 * Skips duplicate toasts for the same message until it is cleared.
 */
export function useReducerErrorToast(errorMessage, options) {
    const { showToast } = useToastContext();
    const lastShownRef = useRef(null);
    const onShownRef = useRef(options?.onShown);
    onShownRef.current = options?.onShown;
    const summary = options?.summary ?? 'Error';
    useEffect(() => {
        const detail = errorMessage?.trim();
        if (!detail) {
            lastShownRef.current = null;
            return;
        }
        if (lastShownRef.current === detail)
            return;
        lastShownRef.current = detail;
        showToast({ severity: 'error', summary, detail });
        onShownRef.current?.();
    }, [errorMessage, showToast, summary]);
}
